module.exports = __webpack_public_path__ + "static/media/CT_2019_30449A_pdf.40f118b9.pdf";